import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Description from './components/Description/Description';
import EnterpriseSection from './components/EnterpriseSection/EnterpriseSection';
import Footer from './components/Footer/Footer';
import ProductSlider from './components/HeroSection/ProductSlider';
import Navbar from './components/Navbar/Navbar';
import ContactPage from './components/Contact/ConactPage';
import About from './components/About/About';
import { HelmetProvider } from 'react-helmet-async';


// Product Pages
import ProcessHeating from './components/Products/ProcessHeating';
import WaterManagement from './components/Products/WaterManagement';
import PowerGeneration from './components/Products/PowerGeneration';
import PollutionControl from './components/Products/PollutionControl';
import Chemicals from './components/Products/Chemicals';
import HVAC from './components/Products/HVAC';
import Solar from './components/Products/Solar';
import SteamAccessories from './components/Products/SteamAccessories';

//steam Assesories 
import ManualValves from './components/Products/ManualValves';
import PneumaticValves from './components/Products/PneumaticValves';
import SafetyValves from './components/Products/SafetyValves';
import NonReturnValves from './components/Products/NonReturnValves';
import SteamTraps from './components/Products/SteamTraps';
import Strainers from './components/Products/Strainers';
import Accessories from './components/Products/Accessories';
import FlowMeters from './components/Products/FlowMeters';
import Others from './components/Products/Others';

// Service Pages
import PipingDesignPage from './components/Services/consulting/PipingDesignPage';
import EnergyAudit from './components/Services/consulting/EnergyAuditPage';
import BoilerAutomation from './components/Services/implementation/BoilerAutomationPage';
import SolidFuelConversionPage from './components/Services/implementation/SolidFuelConversionPage';
import SystemUpgrade from './components/Services/implementation/SystemUpgradesPage';
import Maintenanceservice from './components/Services/maintenance/MaintenanceServicePage';
import EquipmentHealthPage from './components/Services/maintenance/EquipmentHealthPage';
import Descaling from './components/Services/maintenance/Descaling';
import Operation from './components/Services/maintenance/Operation';
import BoilerSpares from './components/Services/spares/BoilerSpares';
import WaterSpares from './components/Services/spares/WaterSpares';
import PoolSpares from './components/Services/spares/PoolSpares';
import CoolingSpares from './components/Services/spares/CoolingSpares';

//Legal Pages 
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import TermsOfService from './components/Legal/TermsOfService';
import Disclaimer from './components/Legal/Disclaimer';

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={
              <>
                <ProductSlider />
                <Description />
                <EnterpriseSection />
              </>
            } />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<About />} />

            {/* Product Routes */}
            <Route path="/products/process-heating" element={<ProcessHeating />} />
            <Route path="/products/water-management" element={<WaterManagement />} />
            <Route path="/products/power-generation" element={<PowerGeneration />} />
            <Route path="/products/pollution-control" element={<PollutionControl />} />
            <Route path="/products/chemicals" element={<Chemicals />} />
            <Route path="/products/hvac" element={<HVAC />} />
            <Route path="/products/solar" element={<Solar />} />
            <Route path="/products/steam-accessories" element={<SteamAccessories />} /> 

            <Route path="/products/manual-valves" element={<ManualValves />} />
            <Route path="/products/pneumatic-valves" element={<PneumaticValves />} />
            <Route path="/products/non-return-valves" element={<NonReturnValves />} />
            <Route path="/products/safety-valves" element={<SafetyValves />} />
            <Route path="/products/steam-traps" element={<SteamTraps />} />
            <Route path="/products/strainers" element={<Strainers />} />
            <Route path="/products/accessories" element={<Accessories />} />
            <Route path="/products/flow-meters" element={<FlowMeters />} />
            <Route path="/products/others" element={<Others />} /> 


            {/* Service Routes */}
            <Route path="/services/consulting/pipingdesign" element={<PipingDesignPage />} />
            <Route path="/services/consulting/energyaudit" element={<EnergyAudit />} />
            <Route path="/services/implementation/boilerautomation" element={<BoilerAutomation />} />
            <Route path="/services/implementation/solidfuelconversion" element={<SolidFuelConversionPage />} />
            <Route path="/services/implementation/upgrades" element={<SystemUpgrade />} />
            <Route path="/services/maintenance/maintenanceservice" element={<Maintenanceservice />} />
            <Route path="/services/maintenance/healthcheckup" element={<EquipmentHealthPage />} />
            <Route path="/services/maintenance/descaling" element={<Descaling />} />
            <Route path="/services/maintenance/operationboiler" element={<Operation />} />
            <Route path ="/services/spares/boiler" element={<BoilerSpares />} />
            <Route path ="/services/spares/w&wspare" element={<WaterSpares />} />
            <Route path ="/services/spares/swimmingpool"element={<PoolSpares />} />
            <Route path="/services/spares/coolingwater" element={<CoolingSpares />} />


            <Route path = "/Legal/privacy" element ={<PrivacyPolicy />} />
            <Route path = "/Legal/termservice" element ={<TermsOfService />} />
            <Route path = "/Legal/disclaimer" element ={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;